import { BadgeCheck } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconBadgeCheck12Line = createIcon(BadgeCheck, 12, "Line");
export const IconBadgeCheck16Line = createIcon(BadgeCheck, 16, "Line");
export const IconBadgeCheck20Line = createIcon(BadgeCheck, 20, "Line");
export const IconBadgeCheck24Line = createIcon(BadgeCheck, 24, "Line");
export const IconBadgeCheck32Line = createIcon(BadgeCheck, 32, "Line");
export const IconBadgeCheck48Line = createIcon(BadgeCheck, 48, "Line");
export const IconBadgeCheck64Line = createIcon(BadgeCheck, 64, "Line");
